import { styled, css } from 'styled-components';

import Button from 'components/Button/Button';
import Form from 'components/Form';

export const Container = styled.div.attrs<{
    $isOpen: boolean;
}>(() => ({}))`
    ${(props) =>
        props.$isOpen &&
        css`
            background-color: var(--color-black-l95);
            inset: 0;
            overflow: auto;
            position: absolute;
        `}
`;

export const StepButton = styled(Button).attrs<{
    $isOpen: boolean;
}>(() => ({}))`
    width: 100%;
    transition: none;
    ${(props) =>
        props.$isOpen &&
        css`
            background-color: var(--color-black-l95);
            border: 0;
            display: flex;
            gap: 0.4375rem;
            padding-block: 1.3125rem;
            position: sticky;
            text-align: left;
            top: 0;
            z-index: 2;
        `}
`;

export const Content = styled.div`
    padding: 1.3125rem;
`;

export const StyledForm = styled(Form)`
    margin-top: 0 !important;
    padding-bottom: 0 !important;
`;
